
import {
  defineComponent,
  ComputedRef,
  computed,
  Ref,
  ref,
  onMounted,
  reactive,
} from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import {
  AdvTableListItem,
  PaginationConfig,
  AccountInfoParamsType,
  BillListResType,
  TableListQueryParams,
  DownloadType
} from "../data.d";

import { useStore } from "vuex";
import { StateType as AccountInfoStateType } from "../store";

import { validateInfos } from "ant-design-vue/lib/form/useForm";
import { message, Form } from "ant-design-vue";
const useForm = Form.useForm;
import useI18nAntdFormVaildateInfos from "@/composables/useI18nAntdFormVaildateInfos";
import dayjs from "dayjs";

import { keepTwoNum, twoFloat } from "@/utils/number";

interface SearchParamsData {
  time: any[];
  billCode: string;
}

interface paginationDir {
  pageNo: number;
  pageSize: number;
}

interface AccountSetupData {
  t: (key: string | number) => string;
  testimg: any;
  columns: Ref<any>;
  pagination: ComputedRef<PaginationConfig>;
  advtablelist: ComputedRef<AdvTableListItem[]>;
  acptablelist: ComputedRef<BillListResType[]>;
  validateInfos: ComputedRef<validateInfos>;
  loading: Ref<boolean>;
  email: Ref<string>;
  accountinfo: Ref<any>;
  modelRef: SearchParamsData;
  isT: Ref<boolean>;
  apiHost: any;
  useType: Ref<number>
  changeTxt: (val: string | number, type: string) => string;
  handleSearch: (e: MouseEvent) => void;
  handleTableChange: (pagination: PaginationConfig) => void;
  handleGoto: (type: string) => void;
  twoNumber: (val: number) => number;
  twoNumber1: (val: number) => number;
  handleDownload: (val: any) => void

}

export default defineComponent({
  name: "AccountQuery",
  setup(): AccountSetupData {
    const { t } = useI18n()
    const store = useStore<{ accountquery: AccountInfoStateType }>()
    const router = useRouter()
    const testimg = require("@/assets/images/avtest.png")
    const loading = ref<boolean>(false)
    const userMsg = JSON.parse(String(localStorage.getItem("userMsg"))) || {}
    const useType = ref<number>(0)
    const email = ref<string>(userMsg.email ?? "");
    const accountinfo = ref<any>({})
    const columns = ref<any>([])
    const isT = ref<boolean>(false)
    const pageNum = reactive<paginationDir>({ pageNo: 1, pageSize: 10 })
    const searchflag = ref<boolean>(false)
    const searchFormData = reactive<any>({})
    const apiHost = process.env.VUE_APP_APIHOST

    //预付账户
    const advtablelist = computed<AdvTableListItem[]>(() => store.state.accountquery.tableData.accountlist)

    //账期账户
    const acptablelist = computed<BillListResType[]>(() => store.state.accountquery.tableData.actbillList)

    //分页
    const pagination = computed<PaginationConfig>(() => store.state.accountquery.tableData.pagination)

    //账号编码获取账户信息
    const getAccountInfo = async (params: AccountInfoParamsType) => {
      try {
        const res:boolean = await store.dispatch('accountquery/getAccountByUserCodeFn', params)
        if(res === true){
          accountinfo.value = store.state.accountquery.accountinfo
          const params = {userCode: userMsg.userCode, ...pageNum}
          if(accountinfo?.value?.accountType == 1){
            getAccountFlowList(params)
          }else{
            getAccountBillList(params)
          }
        }
      } catch (error) {
        message.warning("error=>" + error);
      }
    };

    //账户流水列表(扣费明细)
    const getAccountFlowList = async (params: TableListQueryParams) => {
      loading.value = true;
      try {
        const res:boolean = await store.dispatch("accountquery/getAccountFlowListByPageFn", params)
        if(res===true){
          isT.value = true
          const exhibition = store.state.accountquery.tableData.exhibition
          if(exhibition){
            columns.value = [
                {title: '费用发生时间', dataIndex:'createdAt',align:'center',ellipsis: true,width:160},
                {title: '物流单号', dataIndex:'gwtNo',align:'center',ellipsis: true,width:160},
                {title: '目的国', dataIndex:'country',align:'center',ellipsis: true,width:100},
                {title: '商品属性', dataIndex:'hasBattery',align:'center',ellipsis: true,width:90},
                {title: '产品类别', dataIndex:'productType',align:'center',ellipsis: true,width:80},
                {title: '实际重量(g)', dataIndex:'actualWeight',align:'center',ellipsis: true,width:100},
                {title: '体积重量(g)', dataIndex:'volumeWeight',align:'center',ellipsis: true,width:100},
                {title: '长*宽*高(cm)', dataIndex:'length',align:'center',ellipsis: true,width:120},
                {title: '计费重量(g)', dataIndex:'billingWeight',align:'center',ellipsis: true,width:100},
                {title: '费用项目', dataIndex:'expenseProject',align:'center',ellipsis: true,width:160},
                {title: '金额', dataIndex:'money',align:'center',ellipsis: true,width:100},
                {title: '折后金额', dataIndex:'discountAmount',align:'center',ellipsis: true,width:100},
                {title: '可用余额', dataIndex:'cashAvailable',align:'center',ellipsis: true,width:100},
                {title: '账户总额', dataIndex:'cashTotal',align:'center',ellipsis: true,width:100},
                {title: '计费价格-运费', dataIndex:'chargePrice',align:'center',ellipsis: true,width:140},
                {title: '计费价格-操作费', dataIndex:'unitPrice',align:'center',ellipsis: true,width:140},
                {title: '折扣率', dataIndex:'discount',align:'center',ellipsis: true,width:80},
                {title: '币种', dataIndex:'currency',align:'center',ellipsis: true,width:80},
            ]
          }else{
            columns.value = [
                {title: '费用发生时间', dataIndex:'createdAt',align:'center',ellipsis: true,width:160},
                {title: '物流单号', dataIndex:'gwtNo',align:'center',ellipsis: true,width:160},
                {title: '目的国', dataIndex:'country',align:'center',ellipsis: true,width:100},
                {title: '商品属性', dataIndex:'hasBattery',align:'center',ellipsis: true,width:90},
                {title: '产品类别', dataIndex:'productType',align:'center',ellipsis: true,width:80},
                {title: '下单重量(g)', dataIndex:'orderWeight',align:'center', ellipsis: true, width:100},
                {title: '实际/参考重量(g)', dataIndex:'actualWeight',align:'center',ellipsis: true,width:100},
                {title: '体积重量(g)', dataIndex:'volumeWeight',align:'center',ellipsis: true,width:100},
                {title: '下单长*宽*高(cm)', dataIndex:'length',align:'center',ellipsis: true,width:120},
                {title: '实际/参考长*宽*高(cm)', dataIndex: 'reallength',align:'center', ellipsis: true, width:150},
                {title: '计费重量(g)', dataIndex:'billingWeight',align:'center',ellipsis: true,width:100},
                {title: '费用类型', dataIndex:'expenseType',align:'center', ellipsis: true, width:100},
                {title: '费用项目', dataIndex:'expenseProject',align:'center',ellipsis: true,width:160},
                {title: '金额', dataIndex:'money',align:'center',ellipsis: true,width:100},
                {title: '可用余额', dataIndex:'cashAvailable',align:'center',ellipsis: true,width:100},
                {title: '计费价格-运费', dataIndex:'chargePrice',align:'center',ellipsis: true,width:140},
                {title: '计费价格-操作费', dataIndex:'unitPrice',align:'center',ellipsis: true,width:140},
                {title: '币种', dataIndex:'currency',align:'center',ellipsis: true,width:80},
            ]
          }
        }
      } catch (error) {
        message.warning("error=>" + error);
      }
      loading.value = false;
    };

    //账期账户列表(账单)
    const getAccountBillList = async (params: TableListQueryParams) => {
      loading.value = true;
      try {
        const res:boolean = await store.dispatch("accountquery/getAccountBillListByPageFn", params)
        if(res===true){
          isT.value = true
          columns.value = [
            {title: t("page.account.accountquery.datez"), dataIndex: "billDate",ellipsis: true, align: "center",width:160},
            {title: t("page.account.accountquery.billcode"), dataIndex: "billCode",ellipsis: true, align: "center",width:120},
            {title: t("page.account.accountquery.cycle"), dataIndex: "billCycle",ellipsis: true, align: "left",width:100},
            {title: '物流费用总金额', dataIndex: "totalAmount", ellipsis: true, align: "center",width:140},
            {title: '现金抵扣信用额度金额', dataIndex: "cashCreditAmount", ellipsis: true, align: "center",width:160},
            {title: '现金已扣金额', dataIndex: "paidAmount", ellipsis: true, align: "center",width:100},
            {title: '本期账单应付金额', dataIndex: "payableAmount", ellipsis: true, align: "center",width:120},
            {title: t("page.account.accountquery.currency"), dataIndex: "currency", ellipsis: true, align: "center",width:80},
            {title: t("page.account.accountquery.dueDate"), dataIndex: "billDueDate", ellipsis: true, align: "center",width:160},
            {title: '账单实际付款日', dataIndex: 'actualPaymentTime', align: 'center',width:140},
            {title: t("page.account.accountquery.status"), dataIndex: "billStatus", ellipsis: true, align: "center",width:100},
            {title: '付款期限', dataIndex: 'paymentTerm', align: 'center',width:100},
            {title: t("page.account.accountquery.detailsZ"), dataIndex: "billDetails", ellipsis: true, align: "center",width:100},
          ]
        }
      } catch (error) {
        message.warning("error=>" + error);
      }
      loading.value = false;
    };

    //查询
    const modelRef = reactive<SearchParamsData>({ time: [], billCode: '' });
    const rulesRef = reactive({ time: [], billCode: [] });
    const { validate, validateInfos } = useForm(modelRef, rulesRef);
    const validateInfosNew = useI18nAntdFormVaildateInfos(validateInfos);
    const handleSearch = async (e: MouseEvent) => {
      e.preventDefault();
      try {
        const fieldsValue = await validate<SearchParamsData>()
        const st = (fieldsValue.time && (fieldsValue.time as []).length != 0 && dayjs(fieldsValue.time[0]).format("YYYY-MM-DD 00:00:00")) || ""
        const et = (fieldsValue.time && (fieldsValue.time as []).length != 0 && dayjs(fieldsValue.time[1]).format("YYYY-MM-DD 23:59:59")) || ""
        const bst = (fieldsValue.time && (fieldsValue.time as []).length != 0 && dayjs(fieldsValue.time[0]).format("YYYY-MM-DD")) || ""
        const bet = (fieldsValue.time && (fieldsValue.time as []).length != 0 && dayjs(fieldsValue.time[1]).format("YYYY-MM-DD")) || ""
        searchFormData.value =
          accountinfo?.value?.accountType == 1
            ? {
                expenseStartDate: st,
                expenseEndDate: et,
                userCode: userMsg.userCode,
              }
            : {
                billStartDate: bst,
                billEndDate: bet,
                billCode: fieldsValue.billCode,
                userCode: userMsg.userCode,
              }
        pageNum.pageNo = 1
        searchflag.value = true
        const params = { ...pageNum, ...searchFormData.value }
        accountinfo?.value?.accountType == 1
          ? getAccountFlowList(params)
          : getAccountBillList(params)
      } catch (error) {
        message.warning("error=>" + error)
      }
    };

    //分页
    const handleTableChange = (pagination: PaginationConfig) => {
      pageNum.pageNo = pagination.current;
      pageNum.pageSize = pagination.pageSize;
      const params = searchflag.value
        ? { ...searchFormData.value, ...pageNum }
        : { userCode: userMsg.userCode, ...pageNum };
      accountinfo?.value?.accountType == 1
        ? getAccountFlowList(params)
        : getAccountBillList(params);
    };

    //格式化表格显示内容
    const changeTxt = (val:string | number, type: string):string => {
      const txtEtyObj = {1: '现金',2: '信用', 3: '费用修正-现金', 4: '费用修正-信用'}
      const txtProObj = {
        1: '解冻-扣费&操作费',
        2: '冻结-运费&操作费',
        3: '扣费-运费&操作费',
        4: '扣费-地址修正费',
        5: '扣费-二次派送费',
        6: '扣费-退件费',
        7: '扣费-销毁费',
        8: '扣费-异形费',
        9: '扣费-边远地区/邮编费',
        10: '扣费-仓储费',
        11: '扣费-付款预期利息费',
        12: '返还-运费&操作费',
        13: '现金补充信用额度'
      }
      const txtObjCN = {1: 'CNY'}
      const txtObjST = {1: '已付款', 2: '未付款', 3: '超期未付'}
      const txtDef = {default: String(val)}
      const cycleObj = {1:'一周',2:'两周',3:'三周',10:'一月'}
      const hasBatteryObj = {0:'普货',1:'带电'}
      const prObj = {1:'标准'}
      switch(type){
        case 'expenseType':
          return txtEtyObj[val] || txtDef['default']
        case 'expenseProject':
          return txtProObj[val] || txtDef['default']
        case 'currency':
          return txtObjCN[val] || txtDef['default']
        case 'billStatus':
          return txtObjST[val] || txtDef['default']
        case 'cycle':
          return cycleObj[val] || txtDef['default']
        case 'hasBattery':
          return hasBatteryObj[val] || txtDef['default']
        case 'productType':
          return prObj[val] || txtDef['def']
        case 'paymentTerm':
          if(val<0){
            return '超期未付账单'
          }else if(val==null){
            return '--'
          }else{
            return `剩余${val}天` || txtDef['default']
          }
        default:
          return txtDef['default']
      }
    };

    //初始化
    const init = () => {
      useType.value = userMsg.userType;
      const params = { userCode: userMsg.userCode };
      getAccountInfo(params);
    };

    //跳转
    const handleGoto = (type: string) => {
      let params = {}
      if (type === "recharge") {
        params["path"] = "/account/recharge"
      } else if (type === "cost-fizn") {
        params["path"] = "/account/logistics"
        params["query"] = { expenseProject: 2 }
      } else if(type === 'rechargepop'){
        params["path"] = "/account/recharge"
        params["query"] = {pop: true}
      } else {
        params["path"] = "/account/logistics"
      }
      router.push(params);
    };

    const twoNumber = (val: any) => {
      return keepTwoNum(val);
    };
    const twoNumber1 = (val: any) => {
      return twoFloat(val);
    };

    const handleDownload = (val:any) => {
      console.log(val.billCode)
      let params = {
        billCode: val.billCode
      }
      downloadBtn(params)
    }

    const downloadBtn =async (params:DownloadType) => {
      loading.value = true;
      try {
        await store.dispatch("accountquery/accountBillDownloadFn", params);
      } catch (error) {
        message.warning("error=>" + error);
      }
      loading.value = false;
    }

    onMounted(() => {
      init();
    });
    return {
      t,
      testimg,
      columns,
      advtablelist,
      acptablelist,
      pagination,
      validateInfos: validateInfosNew,
      loading,
      email,
      accountinfo,
      modelRef,
      isT,
      changeTxt,
      handleSearch,
      handleTableChange,
      handleGoto,
      twoNumber,
      twoNumber1,
      handleDownload,
      apiHost,
      useType
    };
  },
});
